// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__eyvqE","modalForm":"UpgradeEpcsModal_modalForm__3Mijx","modalFooter":"UpgradeEpcsModal_modalFooter__3pQMP"};